import type { UserNotification, UserNotificationAlert } from '@dn/libs/ui/dn-common';
import { createAction, props } from '@ngrx/store';

export const LoadUserNotification = createAction('[Notification] load notifications', props<{ userNotificationAlert: UserNotificationAlert }>());

export const SaveUserNotification = createAction('[Notification] save notifications', props<{ userNotification: UserNotification }>());
